import React, { useState, useEffect, useContext, useRef } from "react";
import Navbar from "../component/Navbar.js";
import Footer from "../component/Footer.js";
import Select from "react-select";
import axios from "axios";
import { AuthContext, useSupabase } from "../App";
import "./scroll.css";
import { NavLink } from "react-router-dom";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("PROFILE");
  const [profileType, setProfileType] = useState("PERSONAL");
  const [phone, setPhone] = useState(11);
  // const [id, setId] = useState(12);
  // const [passport, setPassport] = useState(9);
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const { user, isFetching, apiUrl } = useContext(AuthContext);
  const [dial, setDial] = useState([]);
  const [countries, setCountries] = useState([]);
  const [infoCountry, setInfoCountry] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [change, setChange] = useState(false);
  const [popup, setPopup] = useState(false);
  const [click, setClick] = useState("");
  const [history, setHistory] = useState([]);
  const isFirstRender = useRef(true);
  const supabase = useSupabase();

  const [vehicle, setVehicle] = useState({
    years: "",
    brands: "",
    model: "",
    color: "",
    VIN: "",
    engineNumber: "",
    numberPlate: "",
    country: "",
  });

  const [user_personal, setUser_Personal] = useState({
    title: "",
    firstName: "",
    lastName: "",
    idcardNumber: "",
    passportNumber: "",
    nationality: "",
    birthDate: "",
    countryCode: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
  });

  const [user_corporate, setUser_Corporate] = useState({
    companyName: "",
    companyAddress: "",
    title: "",
    firstName: "",
    lastName: "",
    idcardNumber: "",
    passportNumber: "",
    nationality: "",
    birthDate: "",
    countryCode: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
  });

  const [errorPhone, setErrorPhone] = useState("");
  const [errorPassport, setErrorPassport] = useState("");
  const [errorId, setErrorId] = useState("");
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countryRes = await axios.get(`${apiUrl}/country`);
        console.log(countryRes.data);
        const uniqueDials = [];
        countryRes.data.forEach((item) => {
          if (!uniqueDials.some((d) => d.dial === item.dial)) {
            uniqueDials.push({
              dial: item.dial,
              phone: item.phone,
              // id: item.idcard,
              // passport: item.passport,
            });
          }
        });

        setInfoCountry(uniqueDials);
        console.log(uniqueDials);
        const options = uniqueDials.map((item) => ({
          label: item.dial,
          value: item.dial,
        }));
        setDial(options);
        console.log(options);
        const country = [
          ...new Set(countryRes.data.map((item) => item.country)),
        ];
        setCountries(country);
        console.log(country);

        const brandRes = await axios.get(`${apiUrl}/brand`);
        console.log(brandRes.data);
        setBrands(brandRes.data);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, []);

  const updateVehicle = (key, value) => {
    setChange(true);
    setVehicle((prev) => ({ ...prev, [key]: value }));
  };

  const updatePersonal = (key, value) => {
    setChange(true);
    setUser_Personal((prev) => ({ ...prev, [key]: value }));
  };

  const updateCorporate = (key, value) => {
    setChange(true);
    setUser_Corporate((prev) => ({ ...prev, [key]: value }));
  };

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) {
      setEmailError("Invalid email format.");
    } else {
      setEmailError("");
    }
  };

  const validatePhone = (value) => {
    if (value && value.length !== phone) {
      setErrorPhone(`Please input ${phone} numbers`);
    } else {
      setErrorPhone("");
    }
  };

  const validateId = (value) => {
    if (value && (value.length < 9 || value.length > 16)) {
      // setErrorId(`Please input ${id} characters`);
      setErrorId("Please input 9-16 characters");
    } else {
      setErrorId("");
    }
  };

  const validatePassport = (value) => {
    if (value && value.length !== 9) {
      // setErrorPassport(`Please input ${passport} characters`);
      setErrorPassport(`Please input 9 characters`);
    } else {
      setErrorPassport("");
    }
  };

  const sentReview = () => {
    if (rating === 0) {
      alert("Please select rating");
      return;
    }
    axios
      .post(`${apiUrl}/review`, {
        user_id: user?.id,
        rating: rating,
        review: review,
      })
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          alert("Review sent successfully");
          setReview("");
          setRating(0);
        } else {
          alert("Error sending review");
        }
      });
  };

  const saveProfile = () => {
    if (errorPhone || errorPassport || errorId || emailError) {
      alert("Please check your input");
      return;
    }
    if (profileType === "CORPERATE") {
      axios
        .post(`${apiUrl}/changecorporate`, {
          user_id: user?.id,
          companyname: user_corporate.companyName,
          companyaddress: user_corporate.companyAddress,
          title: user_corporate.title,
          firstname: user_corporate.firstName,
          lastname: user_corporate.lastName,
          idcardnumber: user_corporate.idcardNumber,
          passportnumber: user_corporate.passportNumber,
          nationality: user_corporate.nationality,
          dateofbirth: user_corporate.birthDate,
          countrycode: user_corporate.countryCode,
          phonenumber: user_corporate.phoneNumber,
          email: user_corporate.email,
          address: user_corporate.address,
          cit: user_corporate.city,
          zipcode: user_corporate.zipCode,
        })
        .then((res) => {
          console.log(res);
          alert("Updated successfully.");
        })
        .catch((err) => {
          console.error(err);
          alert("There is an error. Please try again.");
        });
    } else if (profileType === "PERSONAL") {
      axios
        .post(`${apiUrl}/changepersonal`, {
          user_id: user?.id,
          title: user_personal.title,
          firstname: user_personal.firstName,
          lastname: user_personal.lastName,
          idcardnumber: user_personal.idcardNumber,
          passportnumber: user_personal.passportNumber,
          nationality: user_personal.nationality,
          dateofbirth: user_personal.birthDate,
          countrycode: user_personal.countryCode,
          phonenumber: user_personal.phoneNumber,
          email: user_personal.email,
          address: user_personal.address,
          city: user_personal.city,
          zipcode: user_personal.zipCode,
        })
        .then((res) => {
          console.log(res);
          alert("Updated successfully.");
        })
        .catch((err) => {
          console.error(err);
          alert("Update failed.");
        });
    }
  };

  const saveInformation = () => {
    axios
      .post(`${apiUrl}/changevehicle`, {
        user_id: user?.id,
        year: vehicle.years,
        brand: vehicle.brands,
        model: vehicle.model,
        color: vehicle.color,
        vin: vehicle.VIN,
        enginenumber: vehicle.engineNumber,
        numberplate: vehicle.numberPlate,
        country: vehicle.country,
      })
      .then((res) => {
        console.log(res);
        alert("Updated successfully.");
      })
      .catch((err) => {
        console.error(err);
        alert("Update failed.");
      });
  };

  const Logout = () => {
    supabase.auth.signOut();
  };

  useEffect(() => {
    if (vehicle.brands !== "") {
      axios
        .get(`${apiUrl}/models/${vehicle.brands}`)
        .then((res) => {
          console.log(res.data);
          setModels(res.data);
        })
        .catch((error) => console.error("Error fetching models:", error));
    }
  }, [vehicle.brands]);

  useEffect(() => {
    if (isFetching || !user) return console.log("Load");
    if (isFirstRender.current) {
      axios.get(`${apiUrl}/brand`).then((res) => {
        console.log(res.data);
        setBrands(res.data);
      });
      axios
        .post(`${apiUrl}/getuserpersonal`, {
          user_id: user?.id,
        })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data[0]);
            const userData = res.data[0];
            setUser_Personal({
              title: userData.title || "",
              firstName: userData.firstname || "",
              lastName: userData.lastname || "",
              idcardNumber: userData.idcardnumber || "",
              passportNumber: userData.passportnumber || "",
              nationality: userData.nationality || "",
              birthDate: userData.dateofbirth || "",
              countryCode: userData.countrycode || "",
              phoneNumber: userData.phonenumber || "",
              email: userData.email || "",
              address: userData.address || "",
              city: userData.city || "",
              zipCode: userData.zipcode || "",
            });
          }
        });
      axios
        .post(`${apiUrl}/getusercorperate`, {
          user_id: user?.id,
        })
        .then((res) => {
          if (res.status === 200) {
            const userData = res.data[0];
            console.log(res.data[0]);
            setUser_Corporate({
              companyName: userData.companyname || "",
              companyAddress: userData.companyaddress || "",
              title: userData.title || "",
              firstName: userData.firstname || "",
              lastName: userData.lastname || "",
              idcardNumber: userData.idcardnumber || "",
              passportNumber: userData.passportnumber || "",
              nationality: userData.nationality || "",
              birthDate: userData.dateofbirth || "",
              countryCode: userData.countrycode || "",
              phoneNumber: userData.phonenumber || "",
              email: userData.email || "",
              address: userData.address || "",
              city: userData.city || "",
              zipCode: userData.zipcode || "",
            });
          }
        });
      axios
        .post(`${apiUrl}/getvehicle`, {
          user_id: user?.id,
        })
        .then((res) => {
          if (res.status === 200) {
            const userData = res.data[0];
            console.log(res.data[0]);
            setVehicle({
              years: userData.year || "",
              brands: userData.brand || "",
              model: userData.model || "",
              color: userData.color || "",
              VIN: userData.vin || "",
              engineNumber: userData.enginenumber || "",
              numberPlate: userData.numberplate || "",
              country: userData.country || "",
            });
          }
        });
      axios
        .post(`${apiUrl}/gethistory`, {
          user_id: user?.id,
        })
        .then((res) => {
          if (res.status === 200) {
            console.log("History:");
            const userData = res.data.map((item) => ({
              date: item.created_at.toString().slice(0, 10),
              product: item.product,
              information: "",
              other: "",
            }));
            setHistory(userData);
          } else {
            console.log("No history found");
          }
        });
      isFirstRender.current = false;
    }
  }, [user]);

  const styleSelect = {
    control: (base) => ({
      ...base,
      boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
      border: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0px",
      paddingRight: "4px",
    }),
    option: (provided) => ({
      ...provided,
      textTransform: "none",
    }),
  };
  return (
    <div>
      {popup && (
        <div className="fixed inset-0 w-screen h-screen bg-black bg-opacity-50 z-[9999]">
          <div className="flex justify-center items-center w-full h-full">
            <div className="relative w-[30vw] h-auto p-12 bg-white rounded-3xl font-poppins text-center">
              Do you want to discard these changes?
              <div className="flex justify-between gap-4 mt-8">
                <button
                  className="px-6 py-2 rounded-lg bg-lime-400 text-gray-700 hover:bg-lime-500"
                  onClick={() => {
                    setChange(false);
                    setActiveTab(click);
                    setPopup(false);
                  }}
                >
                  Yes
                </button>
                <button
                  className="px-6 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600"
                  onClick={() => {
                    setPopup(false);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Navbar />
      <img
        src="/bgprofile.png"
        alt=""
        className="absolute inset-0 w-full h-auto -z-10"
      />
      <NavLink
        className="absolute py-2 px-6 rounded-lg right-40 top-28 bg-red-700 hover:bg-red-800 font-poppins"
        onClick={Logout}
        to="/"
      >
        Log Out
      </NavLink>
      <div className="absolute top-[27vh] left-1/2 transform -translate-x-1/2 w-60 h-60  flex items-center justify-center bg-[#DCDCDC]  rounded-full ">
        <div
          className="absolute w-full h-full bg-transparent rounded-full z-30"
          style={{
            filter: "drop-shadow(-1px -1px 0px rgba(0,0,0,0.25))",
            boxShadow:
              "inset -8px -8px 4px rgba(0, 0, 0, 0.3),inset 8px 8px 4px rgba(255, 255, 255, 0.6)",
          }}
        />
        <div className="absolute w-52 h-52 bg-[#F4F4F4] bg-opacity-90 rounded-full" />
      </div>

      <div className="relative w-[80vw] h-[36vw] flex top-[40vh] -translate-x-1/2 late left-1/2 font-poppins">
        <img src="/subtract.png" alt="" className="absolute w-full h-full" />
        <img
          src={
            activeTab === "PROFILE"
              ? "/bd1.png"
              : activeTab === "INFORMATION"
              ? "/bd2.png"
              : activeTab === "HISTORY"
              ? "/bd3.png"
              : "/bd4.png"
          }
          alt=""
          className="absolute w-full h-auto bottom-0 px-1"
        />
        <div className="relative w-full h-full pb-12 ">
          <div className="flex justify-between space-x-8 mt-16 pb-3 px-28">
            <div className="flex space-x-20">
              {["PROFILE", "INFORMATION"].map((tab) => (
                <button
                  key={tab}
                  className="font-extrabold text-xl pb-2 text-[#00284D]"
                  onClick={() => {
                    if (change) {
                      setClick(tab);
                      setPopup(true);
                    } else {
                      setActiveTab(tab);
                    }
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className="flex space-x-28">
              {["HISTORY", "REVIEW"].map((tab) => (
                <button
                  key={tab}
                  className="font-extrabold text-xl pb-2 text-[#00284D]"
                  onClick={() => {
                    if (change) {
                      setClick(tab);
                      setPopup(true);
                    } else {
                      setActiveTab(tab);
                    }
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
          {activeTab === "PROFILE" && (
            <div className="scroll-container overflow-auto relative h-[25vw] mx-10">
              <div className="relative justify-center mt-6 font-bold text-base ">
                {profileType === "PERSONAL" ? (
                  <div className=" flex items-center justify-center">
                    PERSONAL INFORMATION
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    CORPERATE INFORMATION
                  </div>
                )}
                <div
                  className="relative w-24 h-12 bg-[#940709] rounded-full flex items-center p-1 cursor-pointer left-1/2 -translate-x-1/2"
                  style={{
                    boxShadow:
                      "inset -1px -1px 4px rgba(0, 0, 0, 0.5), inset 3px 4px 3px rgba(0, 0, 0, 0.5)",
                  }}
                  onClick={() => {
                    setErrorId("");
                    setErrorPassport("");
                    setErrorPhone("");
                    setEmailError("");
                    setProfileType(
                      profileType === "PERSONAL" ? "CORPERATE" : "PERSONAL"
                    );
                  }}
                >
                  <div
                    className={`relative flex w-10 h-10 bg-[#EDEDED] rounded-full transition-transform justify-center items-center text-2xl font-bold text-[#940709] ${
                      profileType === "CORPERATE" ? "translate-x-12" : ""
                    }`}
                    style={{
                      filter: "drop-shadow(-2px 1px 4px rgba(0,0,0,0.5))",
                    }}
                  >
                    {profileType === "CORPERATE" ? "C" : "P"}
                  </div>
                </div>
              </div>
              {profileType === "CORPERATE" && (
                <>
                  <div className="flex gap-10 font-bold text-base uppercase font-poppins mx-20 ">
                    <div className="basis-[42%]">
                      <label htmlFor="company-name" className="block pt-4">
                        Company Name
                      </label>
                      <input
                        type="text"
                        id="company-name"
                        placeholder="NAME"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_corporate.companyName}
                        onChange={(e) =>
                          updateCorporate("companyName", e.target.value)
                        }
                      />
                    </div>
                    <div className="basis-[58%]">
                      <label htmlFor="company-address" className="block pt-4">
                        Company Address
                      </label>
                      <input
                        type="text"
                        id="company-address"
                        placeholder="ADDRESS"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_corporate.companyAddress}
                        onChange={(e) =>
                          updateCorporate("companyAddress", e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="flex gap-10 font-bold text-base uppercase font-poppins mx-20">
                    <div className="basis-[12%]">
                      <label htmlFor="title" className="block pt-4">
                        Title
                      </label>
                      <Select
                        options={[
                          { value: "Mr.", label: "Mr." },
                          { value: "Mrs.", label: "Mrs." },
                          { value: "Ms.", label: "Ms." },
                        ]}
                        className="w-full border-none rounded-md text-center"
                        styles={styleSelect}
                        value={
                          user_corporate.title
                            ? {
                                value: user_corporate.title,
                                label: user_corporate.title,
                              }
                            : null
                        }
                        onChange={(option) =>
                          updateCorporate("title", option.value)
                        }
                        placeholder="TITLE"
                        isSearchable={false}
                      />
                    </div>
                    <div className="basis-[44%]">
                      <label htmlFor="first-name" className="block pt-4">
                        First Name
                      </label>
                      <input
                        type="text"
                        id="first-name"
                        placeholder="FIRST NAME"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_corporate.firstName}
                        onChange={(e) =>
                          updateCorporate("firstName", e.target.value)
                        }
                      />
                    </div>
                    <div className="basis-[44%]">
                      <label htmlFor="last-address" className="block pt-4">
                        Last Name
                      </label>
                      <input
                        type="text"
                        id="last-address"
                        placeholder="LAST NAME"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_corporate.lastName}
                        onChange={(e) =>
                          updateCorporate("lastName", e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="flex gap-10 font-bold text-base uppercase font-poppins mx-20">
                    <div className="basis-[38%]">
                      <label htmlFor="idcard-number" className="block pt-4">
                        id card number
                      </label>
                      <input
                        type="text"
                        id="idcard-number"
                        placeholder="ID CARD"
                        maxlength={16}
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_corporate.idcardNumber}
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, "");
                          updateCorporate("idcardNumber", value);
                        }}
                        onBlur={() => validateId(user_corporate.idcardNumber)}
                      />
                      {errorId && (
                        <p className="absolute text-red-500 text-xs ml-2">
                          {errorId}
                        </p>
                      )}
                    </div>
                    <div className="basis-[38%]">
                      <label htmlFor="passport-number" className="block pt-4">
                        PASSPORT NUMBER
                      </label>
                      <input
                        type="text"
                        id="passport-number"
                        placeholder="PASSPORT"
                        maxlength={9}
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_corporate.passportNumber}
                        onChange={(e) =>
                          updateCorporate("passportNumber", e.target.value)
                        }
                        onBlur={() =>
                          validatePassport(user_corporate.passportNumber)
                        }
                      />
                      {errorPassport && (
                        <p className="absolute text-red-500 text-xs ml-2">
                          {errorPassport}
                        </p>
                      )}
                    </div>
                    <div className="basis-[24%]">
                      <label htmlFor="nationality" className="block pt-4">
                        NATIONALITY
                      </label>
                      <Select
                        options={countries.map((c) => ({
                          value: c,
                          label: c,
                        }))}
                        className="border-none rounded-md text-center"
                        styles={styleSelect}
                        value={
                          user_corporate.nationality
                            ? {
                                value: user_corporate.nationality,
                                label: user_corporate.nationality,
                              }
                            : null
                        }
                        onChange={(option) =>
                          updateCorporate("nationality", option.value)
                        }
                        placeholder="NATIONALITY"
                        isSearchable={false}
                      />
                    </div>
                  </div>
                  <div className="flex gap-10 font-bold text-base uppercase font-poppins mx-20">
                    <div className="basis-[18%]">
                      <label htmlFor="date-of-birth" className="block pt-4">
                        DATE OF BIRTH
                      </label>
                      <input
                        type="date"
                        id="date-of-birth"
                        className={`w-full p-2 border-none rounded-md text-center ${
                          !user_corporate.birthDate
                            ? "text-[#808080]"
                            : "text-black"
                        }`}
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={
                          user_corporate.birthDate
                            ? user_corporate.birthDate
                            : null
                        }
                        onChange={(e) =>
                          updateCorporate("birthDate", e.target.value)
                        }
                      />
                    </div>
                    <div className="basis-[43%] ">
                      <label htmlFor="phone-number" className="block pt-4">
                        Phone number
                      </label>
                      <div className="flex items-center gap-2">
                        <Select
                          options={dial}
                          className="basis-[25%] border-none rounded-md text-center "
                          styles={styleSelect}
                          value={
                            user_corporate.countryCode
                              ? {
                                  value: user_corporate.countryCode,
                                  label: user_corporate.countryCode,
                                }
                              : null
                          }
                          onChange={(option) => {
                            const filteredPhones = infoCountry.filter(
                              (item) => item.dial === option.value
                            );
                            console.log(filteredPhones);
                            setPhone(filteredPhones[0].phone);
                            updateCorporate("countryCode", option.value);
                            updateCorporate("phoneNumber", "");
                            setErrorPhone("");
                          }}
                          placeholder="+66"
                          isSearchable={false}
                        />
                        <div className="flex flex-col basis-[75%] relative">
                          <input
                            type="text"
                            id="phone-number"
                            maxlength={10}
                            placeholder="81 123 4567"
                            className=" p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                            style={{
                              boxShadow:
                                "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                            }}
                            value={user_corporate.phoneNumber}
                            onChange={(e) => {
                              let value = e.target.value.replace(/\D/g, "");
                              updateCorporate("phoneNumber", value);
                            }}
                            onBlur={() =>
                              validatePhone(user_corporate.phoneNumber)
                            }
                          />
                          {errorPhone && (
                            <p className="absolute top-full text-red-500 text-xs ml-2">
                              {errorPhone}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="basis-[39%]">
                      <label htmlFor="email" className="block pt-4">
                        email
                      </label>
                      <input
                        type="email"
                        id="email"
                        placeholder="EMAIL"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_corporate.email}
                        onChange={(e) => {
                          updateCorporate("email", e.target.value);
                          validateEmail(e.target.value);
                        }}
                      />
                      {emailError && (
                        <p className="absolute text-red-500 text-xs ml-2">
                          {emailError}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex gap-10 font-bold text-base uppercase font-poppins mx-20">
                    <div className="basis-[38%]">
                      <label htmlFor="address" className="block pt-4">
                        address
                      </label>
                      <input
                        type="text"
                        id="address"
                        placeholder="ADDRESS"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_corporate.address}
                        onChange={(e) =>
                          updateCorporate("address", e.target.value)
                        }
                      />
                    </div>
                    <div className="basis-[20%]">
                      <label htmlFor="city" className="block pt-4">
                        City
                      </label>
                      <Select
                        options={[
                          { value: "Johor", label: "Johor" },
                          { value: "Kedah", label: "Kedah" },
                          { value: "Kelantan", label: "Kelantan" },
                          {
                            value: "Malacca (Melaka)",
                            label: "Malacca (Melaka)",
                          },
                          {
                            value: "Negeri Sembilan",
                            label: "Negeri Sembilan",
                          },
                          { value: "Pahang", label: "Pahang" },
                          {
                            value: "Penang (Pulau Pinang)",
                            label: "Penang (Pulau Pinang)",
                          },
                          { value: "Perak", label: "Perak" },
                          { value: "Perlis", label: "Perlis" },
                          { value: "Sabah", label: "Sabah" },
                          { value: "Sarawak", label: "Sarawak" },
                          { value: "Selangor", label: "Selangor" },
                          { value: "Terengganu", label: "Terengganu" },
                          { value: "Kuala Lumpur", label: "Kuala Lumpur" },
                          { value: "Labuan", label: "Labuan" },
                          { value: "Putrajaya", label: "Putrajaya" },
                        ]}
                        className="w-full border-none rounded-md text-center"
                        styles={styleSelect}
                        value={
                          user_corporate.city
                            ? {
                                value: user_corporate.city,
                                label: user_corporate.city,
                              }
                            : null
                        }
                        onChange={(option) =>
                          updateCorporate("city", option.value)
                        }
                        placeholder="CITY"
                      />
                    </div>
                    <div className="basis-[20%]">
                      <label htmlFor="zip-code" className="block pt-4">
                        zip code
                      </label>
                      <input
                        type="text"
                        id="zip-code"
                        placeholder="ZIP"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_corporate.zipCode}
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, "");
                          updateCorporate("zipCode", value);
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
              {profileType === "PERSONAL" && (
                <>
                  <div className="flex gap-10 font-bold text-base uppercase font-poppins mx-20">
                    <div className="basis-[12%]">
                      <label htmlFor="title" className="block pt-4">
                        Title
                      </label>
                      <Select
                        options={[
                          { value: "Mr.", label: "Mr." },
                          { value: "Mrs.", label: "Mrs." },
                          { value: "Ms.", label: "Ms." },
                        ]}
                        className="w-full border-none rounded-md text-center"
                        styles={styleSelect}
                        value={
                          user_personal.title
                            ? {
                                value: user_personal.title,
                                label: user_personal.title,
                              }
                            : null
                        }
                        onChange={(option) =>
                          updatePersonal("title", option.value)
                        }
                        placeholder="TITLE"
                        isSearchable={false}
                      />
                    </div>
                    <div className="basis-[44%]">
                      <label htmlFor="first-name" className="block pt-4">
                        First Name
                      </label>
                      <input
                        type="text"
                        id="first-name"
                        placeholder="FIRST NAME"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_personal.firstName}
                        onChange={(e) =>
                          updatePersonal("firstName", e.target.value)
                        }
                      />
                    </div>
                    <div className="basis-[44%]">
                      <label htmlFor="last-address" className="block pt-4">
                        Last Name
                      </label>
                      <input
                        type="text"
                        id="last-address"
                        placeholder="LAST NAME"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_personal.lastName}
                        onChange={(e) =>
                          updatePersonal("lastName", e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="flex gap-10 font-bold text-base uppercase font-poppins mx-20">
                    <div className="basis-[38%]">
                      <label htmlFor="idcard-number" className="block pt-4">
                        id card number
                      </label>
                      <input
                        type="text"
                        id="idcard-number"
                        placeholder="ID CARD"
                        maxlength={16}
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_personal.idcardNumber}
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, "");
                          updatePersonal("idcardNumber", value);
                        }}
                        onBlur={() => validateId(user_personal.idcardNumber)}
                      />
                      {errorId && (
                        <p className="absolute text-red-500 text-xs ml-2">
                          {errorId}
                        </p>
                      )}
                    </div>
                    <div className="basis-[38%]">
                      <label htmlFor="passport-number" className="block pt-4">
                        PASSPORT NUMBER
                      </label>
                      <input
                        type="text"
                        id="passport-number"
                        placeholder="PASSPORT"
                        maxlength={9}
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_personal.passportNumber}
                        onChange={(e) =>
                          updatePersonal("passportNumber", e.target.value)
                        }
                        onBlur={() =>
                          validatePassport(user_personal.passportNumber)
                        }
                      />
                      {errorPassport && (
                        <p className="absolute text-red-500 text-xs ml-2">
                          {errorPassport}
                        </p>
                      )}
                    </div>
                    <div className="basis-[24%]">
                      <label htmlFor="nationality" className="block pt-4">
                        NATIONALITY
                      </label>
                      <Select
                        options={countries.map((c) => ({
                          value: c,
                          label: c,
                        }))}
                        className="border-none rounded-md text-center"
                        styles={styleSelect}
                        value={
                          user_personal.nationality
                            ? {
                                value: user_personal.nationality,
                                label: user_personal.nationality,
                              }
                            : null
                        }
                        onChange={(option) =>
                          updatePersonal("nationality", option.value)
                        }
                        placeholder="NATIONALITY"
                        isSearchable={false}
                      />
                    </div>
                  </div>
                  <div className="flex gap-10 font-bold text-base uppercase font-poppins mx-20">
                    <div className="basis-[18%]">
                      <label htmlFor="date-of-birth" className="block pt-4">
                        DATE OF BIRTH
                      </label>
                      <input
                        type="date"
                        id="date-of-birth"
                        className={`w-full p-2 border-none rounded-md text-center ${
                          !user_personal.birthDate
                            ? "text-[#808080]"
                            : "text-black"
                        }`}
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={
                          user_personal.birthDate
                            ? user_personal.birthDate
                            : null
                        }
                        onChange={(e) =>
                          updatePersonal("birthDate", e.target.value)
                        }
                      />
                    </div>
                    <div className="basis-[43%] ">
                      <label htmlFor="phone-number" className="block pt-4">
                        Phone number
                      </label>
                      <div className="flex items-center gap-2">
                        <Select
                          options={dial}
                          className="basis-[25%] border-none rounded-md text-center "
                          styles={styleSelect}
                          value={
                            user_personal.countryCode
                              ? {
                                  value: user_personal.countryCode,
                                  label: user_personal.countryCode,
                                }
                              : null
                          }
                          onChange={(option) => {
                            const filteredPhones = infoCountry.filter(
                              (item) => item.dial === option.value
                            );
                            console.log(filteredPhones);
                            setPhone(filteredPhones[0].phone);
                            updatePersonal("countryCode", option.value);
                            updatePersonal("phoneNumber", "");
                            setErrorPhone("");
                          }}
                          placeholder="+66"
                          isSearchable={false}
                        />
                        <div className="flex flex-col basis-[75%] relative">
                          <input
                            type="text"
                            id="phone-number"
                            maxlength={10}
                            placeholder="81 123 4567"
                            className=" p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                            style={{
                              boxShadow:
                                "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                            }}
                            value={user_personal.phoneNumber}
                            onChange={(e) => {
                              let value = e.target.value.replace(/\D/g, "");
                              updatePersonal("phoneNumber", value);
                            }}
                            onBlur={() =>
                              validatePhone(user_personal.phoneNumber)
                            }
                          />
                          {errorPhone && (
                            <p className="absolute top-full text-red-500 text-xs ml-2">
                              {errorPhone}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="basis-[39%]">
                      <label htmlFor="email" className="block pt-4">
                        email
                      </label>
                      <input
                        type="email"
                        id="email"
                        placeholder="EMAIL"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_personal.email}
                        onChange={(e) => {
                          updatePersonal("email", e.target.value);
                          validateEmail(e.target.value);
                        }}
                      />
                      {emailError && (
                        <p className="absolute text-red-500 text-xs ml-2">
                          {emailError}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex gap-10 font-bold text-base uppercase font-poppins mx-20">
                    <div className="basis-[38%]">
                      <label htmlFor="address" className="block pt-4">
                        address
                      </label>
                      <input
                        type="text"
                        id="address"
                        placeholder="ADDRESS"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_personal.address}
                        onChange={(e) =>
                          updatePersonal("address", e.target.value)
                        }
                      />
                    </div>
                    <div className="basis-[20%]">
                      <label htmlFor="city" className="block pt-4">
                        City
                      </label>
                      <Select
                        options={[
                          { value: "Johor", label: "Johor" },
                          { value: "Kedah", label: "Kedah" },
                          { value: "Kelantan", label: "Kelantan" },
                          {
                            value: "Malacca (Melaka)",
                            label: "Malacca (Melaka)",
                          },
                          {
                            value: "Negeri Sembilan",
                            label: "Negeri Sembilan",
                          },
                          { value: "Pahang", label: "Pahang" },
                          {
                            value: "Penang (Pulau Pinang)",
                            label: "Penang (Pulau Pinang)",
                          },
                          { value: "Perak", label: "Perak" },
                          { value: "Perlis", label: "Perlis" },
                          { value: "Sabah", label: "Sabah" },
                          { value: "Sarawak", label: "Sarawak" },
                          { value: "Selangor", label: "Selangor" },
                          { value: "Terengganu", label: "Terengganu" },
                          { value: "Kuala Lumpur", label: "Kuala Lumpur" },
                          { value: "Labuan", label: "Labuan" },
                          { value: "Putrajaya", label: "Putrajaya" },
                        ]}
                        className="w-full border-none rounded-md text-center"
                        styles={styleSelect}
                        value={
                          user_personal.city
                            ? {
                                value: user_personal.city,
                                label: user_personal.city,
                              }
                            : null
                        }
                        onChange={(option) =>
                          updatePersonal("city", option.value)
                        }
                        placeholder="CITY"
                      />
                    </div>
                    <div className="basis-[20%]">
                      <label htmlFor="zip-code" className="block pt-4">
                        zip code
                      </label>
                      <input
                        type="text"
                        id="zip-code"
                        placeholder="ZIP"
                        className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={user_personal.zipCode}
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, "");
                          updatePersonal("zipCode", value);
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="flex items-center justify-center pt-4">
                <button
                  className="font-bold text-white rounded-full w-auto"
                  style={{
                    backgroundImage: "url(/gold_bg.png)",
                    backgroundSize: "cover",
                  }}
                  onClick={saveProfile}
                >
                  <div className="w-full h-full px-7 py-2 text-xl bg-[#9D7B14] bg-opacity-50 rounded-full">
                    Save
                  </div>
                </button>
              </div>
            </div>
          )}

          {activeTab === "INFORMATION" && (
            <div
              id="VEHICLE INFORMATION"
              className="space-y-1 pt-4 mx-10 text-black font-bold text-base font-poppins uppercase scroll-container overflow-auto relative h-[25vw]"
            >
              <div className="space-y-1">
                <div className="flex gap-10 px-20">
                  <div className="basis-[21%]">
                    <label htmlFor="years" className="block  pt-4">
                      Years
                    </label>
                    <Select
                      options={Array.from(
                        { length: new Date().getFullYear() - 1995 },
                        (_, i) => ({ value: 1996 + i, label: 1996 + i })
                      )}
                      className="w-full border-none rounded-md text-center"
                      styles={styleSelect}
                      value={
                        vehicle.years
                          ? { value: vehicle.years, label: vehicle.years }
                          : null
                      }
                      onChange={(option) =>
                        updateVehicle("years", option.value)
                      }
                      placeholder="YEARS"
                    />
                  </div>
                  <div className="basis-[29%]">
                    <label htmlFor="brands" className="block pt-4">
                      Brands
                    </label>
                    <Select
                      options={brands.map((b) => ({ value: b, label: b }))}
                      className="w-full border-none rounded-md text-center"
                      styles={styleSelect}
                      value={
                        vehicle.brands
                          ? { value: vehicle.brands, label: vehicle.brands }
                          : null
                      }
                      onChange={(option) =>
                        updateVehicle("brands", option.value)
                      }
                      placeholder="BRANDS"
                    />
                  </div>
                  <div className="basis-[31%]">
                    <label htmlFor="model" className="block pt-4">
                      Model
                    </label>
                    <Select
                      options={models.map((m) => ({
                        value: m.model,
                        label: m.model,
                      }))}
                      className="w-full border-none rounded-md text-center"
                      styles={styleSelect}
                      value={
                        vehicle.model
                          ? { value: vehicle.model, label: vehicle.model }
                          : null
                      }
                      onChange={(option) =>
                        updateVehicle("model", option.value)
                      }
                      placeholder="MODEL"
                    />
                  </div>
                  <div className="basis-[19%]">
                    <label htmlFor="color" className="block pt-4">
                      Color
                    </label>
                    <Select
                      options={[
                        { value: "White", label: "White" },
                        { value: "Black", label: "Black" },
                        { value: "Gray", label: "Gray" },
                        { value: "Silver", label: "Silver" },
                        { value: "Red", label: "Red" },
                        { value: "Blue", label: "Blue" },
                        { value: "Yellow", label: "Yellow" },
                        { value: "Green", label: "Green" },
                        { value: "Orange", label: "Orange" },
                        { value: "Purple", label: "Purple" },
                        { value: "Metallic Blue", label: "Metallic Blue" },
                        { value: "Metallic Gray", label: "Metallic Gray" },
                        {
                          value: "Metallic Silver",
                          label: "Metallic Silver",
                        },
                        { value: "Metallic Red", label: "Metallic Red" },
                        { value: "Pearl White", label: "Pearl White" },
                        { value: "Gold", label: "Gold" },
                        { value: "Copper", label: "Copper" },
                        { value: "Matte Colors", label: "Matte Colors" },
                        { value: "Matte Black", label: "Matte Black" },
                        { value: "Matte Gray", label: "Matte Gray" },
                        { value: "Matte Blue", label: "Matte Blue" },
                        { value: "Matte Red", label: "Matte Red" },
                        { value: "Two-Tone", label: "Two-Tone" },
                        { value: "Champagne", label: "Champagne" },
                        { value: "Teal", label: "Teal" },
                        { value: "Turquoise", label: "Turquoise" },
                        { value: "Lavender", label: "Lavender" },
                        { value: "Magenta", label: "Magenta" },
                        { value: "Burgundy", label: "Burgundy" },
                        { value: "Lime Green", label: "Lime Green" },
                        { value: "Rose Gold", label: "Rose Gold" },
                        { value: "Midnight Blue", label: "Midnight Blue" },
                        { value: "Forest Green", label: "Forest Green" },
                        { value: "Electric Blue", label: "Electric Blue" },
                        { value: "Neon Yellow", label: "Neon Yellow" },
                        { value: "Gunmetal Gray", label: "Gunmetal Gray" },
                        {
                          value: "Chocolate Brown",
                          label: "Chocolate Brown",
                        },
                      ]}
                      className="w-full border-none rounded-md text-center"
                      styles={styleSelect}
                      value={
                        vehicle.color
                          ? { value: vehicle.color, label: vehicle.color }
                          : null
                      }
                      onChange={(option) =>
                        updateVehicle("color", option.value)
                      }
                      placeholder="COLOR"
                    />
                  </div>
                </div>
              </div>
              <div className="flex gap-10 px-20">
                <div className=" basis-[39%]">
                  <label htmlFor="vin" className="block pt-4">
                    VIN ( Vehicle Identification Number )
                  </label>
                  <input
                    type="text"
                    id="vin"
                    placeholder="VIN"
                    className="w-full p-2 border-none rounded-md  text-center text-ellipsis placeholder-[#808080]"
                    style={{
                      boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                    }}
                    value={vehicle.VIN}
                    onChange={(e) => {
                      updateVehicle("VIN", e.target.value);
                      updateVehicle("engineNumber", e.target.value);
                    }}
                  />
                </div>
                <div className=" basis-[36%]">
                  <label
                    htmlFor="engine-number"
                    className="block pt-4 text-red-500"
                  >
                    Engine number
                  </label>
                  <div
                    id="engine-number"
                    className={`w-full p-2 border-none rounded-md text-center text-ellipsis ${
                      vehicle.engineNumber === "" ? "text-[#808080]" : ""
                    }`}
                    style={{
                      boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    {vehicle.engineNumber === ""
                      ? "Engine number"
                      : vehicle.engineNumber}
                  </div>
                </div>
                <div className=" basis-[25%]">
                  <label htmlFor="number-plate" className="block pt-4">
                    PLATE NUMBER
                  </label>
                  <input
                    type="text"
                    id="number-plate"
                    placeholder="NUMBER"
                    className="w-full p-2 border-none rounded-md text-center text-ellipsis placeholder-[#808080]"
                    style={{
                      boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                    }}
                    value={vehicle.numberPlate}
                    onChange={(e) =>
                      updateVehicle("numberPlate", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="flex px-20">
                <div className=" basis-[23%]">
                  <label htmlFor="country" className="block pt-4">
                    Country
                  </label>
                  <Select
                    options={countries.map((c) => ({ value: c, label: c }))}
                    className="w-full border-none rounded-md text-center"
                    styles={styleSelect}
                    value={
                      vehicle.country
                        ? {
                            value: vehicle.country,
                            label: vehicle.country,
                          }
                        : null
                    }
                    onChange={(option) =>
                      updateVehicle("country", option.value)
                    }
                    placeholder="COUNTRY"
                  />
                </div>
              </div>
              <div className="flex items-center justify-center pt-4">
                <button
                  className="font-bold text-white rounded-full w-auto"
                  style={{
                    backgroundImage: "url(/gold_bg.png)",
                    backgroundSize: "cover",
                  }}
                  onClick={saveInformation}
                >
                  <div className="w-full h-full px-7 py-2 text-xl bg-[#9D7B14] bg-opacity-50 rounded-full">
                    Save
                  </div>
                </button>
              </div>
            </div>
          )}
          {activeTab === "HISTORY" && (
            <div className="overflow-x-auto pt-4 px-10 mx-10 scroll-container relative h-[25vw]">
              <table className="w-full table-fixed text-black font-poppins font-medium text-base text-center mb-6">
                <thead>
                  <tr className="border-b-2 border-black text-[#8F8F8F] ">
                    <td className="w-[22%] px-2 py-2">Date Of Purchase</td>
                    <td className="w-[22%] px-2 py-2">Product</td>
                    <td className="w-[28%] px-2 py-2">Information</td>
                    <td className="w-[28%] px-2 py-2">Other</td>
                  </tr>
                </thead>
                <tbody>
                  {history.map((item, index) => (
                    <tr key={index} className="border-b-2 border-black">
                      <td className="w-[22%] px-2 py-3">{item.date}</td>
                      <td className="w-[22%] px-2 py-3">{item.product}</td>
                      <td className="w-[28%] px-2 py-3">{item.information}</td>
                      <td className="w-[28%] px-2 py-3">{item.other}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "REVIEW" && (
            <div className="mt-6 text-center px-20 flex flex-col items-center justify-center">
              <h3 className="text-base font-medium font-poppins">
                REVIEW FROM YOUR HEART
              </h3>
              <div className="flex justify-center mt-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={`text-3xl cursor-pointer ${
                      star <= rating ? "text-red-500" : "text-red-800"
                    }`}
                    onClick={() => setRating(star)}
                  >
                    ❤
                  </span>
                ))}
              </div>
              <div className="font-pragati mt-2 ">
                <div className="text-left text-[#909090] text-sm">
                  DETAIL REVIEW
                </div>
                <textarea
                  className="flex w-[25vw] h-[12vw] p-2 border rounded bg-white text-base  resize-none"
                  style={{
                    boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                  }}
                  rows="4"
                  value={review}
                  onChange={(e) => setReview(e.target.value)}
                />
              </div>

              <button
                className="flex mt-3 px-12 py-3 bg-[#0F2C59] hover:bg-[#1c3964] text-white rounded font-bold text-lg font-pragati"
                style={{
                  boxShadow:
                    "inset 2px -2px 4px rgba(0, 0, 0, 0.5),inset -2px 2px 4px rgba(255, 255, 255, 0.5)",
                  filter: "drop-shadow(-3px 3px 4px rgba(0, 0, 0, 0.6))",
                }}
                onClick={() => sentReview()}
              >
                SEND
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="w-full h-[35vh]" />
      <img
        src="/lastbanner.png"
        className="relative w-[40vw] h-auto left-1/2 -translate-x-1/2 mb-10"
        alt=""
      />
      <Footer />
    </div>
  );
};

export default Profile;
